import Model from "./Model";

export default class Stage extends Model {
  resource() {
    return "stages";
  }
}
